var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"label":_vm.label,"rules":_vm.rules,"items":_vm.items,"filter":_vm.filter,"item-text":"name","clearable":""},model:{value:(_vm.childData),callback:function ($$v) {_vm.childData=$$v},expression:"childData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }